<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.iconColor'
      showEdit
      @edit='edit'
    >
      <wc-two-column-table
        :items='data'
        @rowClick='edit'
      ></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='toolbarData.title'
      :icon='toolbarData.icon'
      @cancel='showDialog = false'
      @save='save'
      width='350'
    >
      <confidentials-form v-model='profileCopy'></confidentials-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import ConfidentialsForm from '../../components/forms/ConfidentialsForm'

export default {
  name: 'confidential',
  data: () => ({
    isLoading: false,
    showDialog: false,
    profileCopy: {}
  }),
  props: {
    profile: {
      required: true
    }
  },
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.details
    },
    data () {
      if (this.profile) {
        return [
          { text: 'Default start time', value: this.$options.filters.time(this.profile.default_start) },
          { text: 'Default end time', value: this.$options.filters.time(this.profile.default_end) },
          { text: 'Can be lead?', value: this.$options.filters.trueFalse(this.profile.can_be_lead) },
          { text: 'Is high season help?', value: this.$options.filters.trueFalse(this.profile.high_season_help) },
          { text: 'Is subcontractor?', value: this.$options.filters.trueFalse(this.profile.is_subcontractor) },
        ]
      }
      return []
    }
  },
  methods: {
    edit () {
      this.profileCopy = _.cloneDeep(this.profile)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.profileCopy)
      this.showDialog = false
    }
  },
  components: {
    'confidentials-form': ConfidentialsForm
  }
}
</script>
